<template>
  <div class="prompt-result-view">
    <header class="view-header">
      <h1 class="title--large">
        AI Credit Analysis
      </h1>
    </header>
  
    <main class="conversation-container">
      <CalicoPromptResult
        prompt="What's my credit approval probability?"
        message="BetaScore AI"
        content="This is a predictive analysis based on your data. The approval probability is 85%."
      />
  
      <CalicoPromptResult
        prompt="How can I improve my credit score?"
        message="BetaScore AI"
        content="Recommendation: Improve your credit score by paying your pending debts and keeping credit utilization below 30%."
      />
    </main>
  </div>
</template>
  
  <script>
  import CalicoPromptResult from '@/components/pattern/promptResult/index.vue';
  
  export default {
    name: 'PromptResultView',
    components: {
      CalicoPromptResult
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .prompt-result-view {
    @include stack-space($space-xxlarge);
    max-width: 800px;
    margin: 0 auto;
    padding: $space-large;
  
    .view-header {
      @include stack-space($space-medium);
      text-align: center;
      padding-bottom: $space-large;
      border-bottom: 1px solid $color-neutral-light;
    }
  
    .conversation-container {
      @include stack-space($space-xxlarge);
    }
  }
  </style>